/** Get an agent conversation and its turns */
export const agentConversationGetSpec = {
    uri: '/agent/conversation/[conversation]',
    method: 'GET',
    adminOnly: true,
};
